const VIEWPORT_PAD = 8;

/**
 * Place a floating panel dynamically. Flips above the trigger if space is insufficient.
 */
export function computeFloatingPanel(anchorEl, { minWidth = 256, gap = 8, estimatedHeight = 280 } = {}) {
  if (!anchorEl) return null;

  const rect = anchorEl.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Check if we need to flip above
  const spaceBelow = viewportHeight - rect.bottom - gap - VIEWPORT_PAD;
  const spaceAbove = rect.top - gap - VIEWPORT_PAD;

  let direction = 'below';
  if (spaceBelow < estimatedHeight && spaceAbove > spaceBelow) {
    direction = 'above';
  }

  const top = direction === 'above' 
    ? rect.top - estimatedHeight - gap 
    : rect.bottom + gap;

  let width = Math.max(minWidth, rect.width);
  let left = rect.left;

  if (left + width > viewportWidth - VIEWPORT_PAD) {
    left = viewportWidth - width - VIEWPORT_PAD;
  }
  if (left < VIEWPORT_PAD) {
    left = VIEWPORT_PAD;
    width = Math.min(width, viewportWidth - 2 * VIEWPORT_PAD);
  }

  return {
    top,
    left,
    width,
    direction
  };
}

/**
 * Place a floating panel below the anchor. Never flips above the trigger.
 */
export function computeFloatingPanelBelow(anchorEl, { minWidth = 256, gap = 8 } = {}) {
  if (!anchorEl) return null;

  const rect = anchorEl.getBoundingClientRect();
  const viewportWidth = window.innerWidth;

  const top = rect.bottom + gap;
  let width = Math.max(minWidth, rect.width);
  let left = rect.left;

  if (left + width > viewportWidth - VIEWPORT_PAD) {
    left = viewportWidth - width - VIEWPORT_PAD;
  }
  if (left < VIEWPORT_PAD) {
    left = VIEWPORT_PAD;
    width = Math.min(width, viewportWidth - 2 * VIEWPORT_PAD);
  }

  return {
    top,
    left,
    width,
    direction: 'below'
  };
}
